import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'letter-l', 'LetterL', [["path",{"d":"M7 4v16h10","key":"svg-0"}]]);